/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */

// import Tabs from "./modules/Tabs";
import SearchTabs from "../modules/SearchTabs";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener(
	"DOMContentLoaded",
	() => {
		// const myPageScroll = new PageScroll();
		const initSearchTabs = new SearchTabs();
		// const initPromoSlider = new PromoSlider();
		// const myTabs = new Tabs("jsInfoTabs");

	}
);
